import { URITypeMap } from './enums/uri_type';
import { parseURI } from './uri';
export function isAdURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.AD;
}
export function isAlbumURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.ALBUM;
}
export function isApplicationURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.APPLICATION;
}
export function isArtistURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.ARTIST;
}
export function isArtistToplistURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.ARTIST_TOPLIST;
}
export function isArtistConcertsURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.ARTIST_CONCERTS;
}
export function isAudioFileURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.AUDIO_FILE;
}
export function isCanvasURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.CANVAS;
}
export function isCollectionURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.COLLECTION;
}
export function isCommentURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.COMMENT;
}
export function isConceptURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.CONCEPT;
}
export function isCulturalMomentURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.CULTURAL_MOMENT;
}
export function isGenreURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.GENRE;
}
export function isQueueURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.QUEUE;
}
export function isCollectionAlbumURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.COLLECTION_ALBUM;
}
export function isCollectionArtistURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.COLLECTION_ARTIST;
}
export function isCollectionMissingAlbumURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.COLLECTION_MISSING_ALBUM;
}
export function isCollectionTrackListURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.COLLECTION_TRACK_LIST;
}
export function isConcertURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.CONCERT;
}
export function isContextGroupURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.CONTEXT_GROUP;
}
export function isDailyMixURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.DAILY_MIX;
}
export function isEmptyURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.EMPTY;
}
export function isEpisodeURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.EPISODE;
}
export function isFacebookURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.FACEBOOK;
}
export function isFestivalURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.FESTIVAL;
}
export function isFolderURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.FOLDER;
}
export function isFollowersURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.FOLLOWERS;
}
export function isFollowingURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.FOLLOWING;
}
export function isImageURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.IMAGE;
}
export function isInboxURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.INBOX;
}
export function isInterruptionURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.INTERRUPTION;
}
export function isLibraryURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.LIBRARY;
}
export function isLiveURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.LIVE;
}
export function isRoomURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.ROOM;
}
export function isExpressionURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.EXPRESSION;
}
export function isLocalURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.LOCAL;
}
export function isLocalTrackURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.LOCAL_TRACK;
}
export function isLocalAlbumURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.LOCAL_ALBUM;
}
export function isLocalArtistURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.LOCAL_ARTIST;
}
export function isMerchURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.MERCH;
}
export function isMerchHubURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.MERCHHUB;
}
export function isMosaicURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.MOSAIC;
}
export function isPlaylistV1URI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.PLAYLIST;
}
/**
 * @deprecated Use `isPlaylistV1URI` instead.
 */
export const isPlaylistURI = isPlaylistV1URI;
export function isPlaylistV2URI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.PLAYLIST_V2;
}
export function isPlaylistV1OrV2URI(uri) {
    return isPlaylistV1URI(uri) || isPlaylistV2URI(uri);
}
export function isPrereleaseURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.PRERELEASE;
}
export function isProfileURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.PROFILE;
}
export function isPublishedRootlistURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.PUBLISHED_ROOTLIST;
}
export function isRadioURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.RADIO;
}
export function isRootlistURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.ROOTLIST;
}
export function isSearchURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.SEARCH;
}
export function isShowURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.SHOW;
}
export function isSocialSessionURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.SOCIAL_SESSION;
}
export function isSpecialURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.SPECIAL;
}
export function isStarredURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.STARRED;
}
export function isStationURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.STATION;
}
export function isTemporaryPlaylistURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.TEMP_PLAYLIST;
}
export function isToplistURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.TOPLIST;
}
export function isTourURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.TOUR;
}
export function isTrackURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.TRACK;
}
export function isTracksetURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.TRACKSET;
}
export function isUserToplistURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.USER_TOPLIST;
}
export function isUserTopTracksURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.USER_TOP_TRACKS;
}
export function isUnknownURI(uri) {
    var _a;
    return ((_a = parseURI(uri, { parseUnknown: true })) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.UNKNOWN;
}
export function isVenueURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.VENUE;
}
export function isVideoURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.VIDEO;
}
export function isMediaURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.MEDIA;
}
export function isPollURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.POLL;
}
export function isQuestionURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.QUESTION;
}
export function isResponseURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.RESPONSE;
}
export function isCourseURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.COURSE;
}
export function isLessonURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.LESSON;
}
export function isPromoterURI(uri) {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.PROMOTER;
}
//# sourceMappingURL=type_guards.js.map